import { POPUP, VALIDATE_BOOKING } from '../constants'

const initState = {
	request: null,
	response: null,
	error: null,
}

export default (state = initState, action) => {
	switch (action.type) {
		case VALIDATE_BOOKING.LOAD:
			return {
				...state,
				request: action.request,
				response: null,
				error: null,
			}
		case VALIDATE_BOOKING.SUCCESS:
			return {
				...state,
				response: action.response,
			}
		case VALIDATE_BOOKING.ERROR:
			return {
				...state,
				error: action.error,
			}
		case VALIDATE_BOOKING.CLEAR:
			return {
				...state,
				response: null,
				error: null,
			}
		case POPUP.CLOSE:
			return {
				...state,
				error: null,
			}
		default:
			return state
	}
}
